module.exports = __webpack_public_path__ + "static/media/it3.8fc76a1a.svg";